/* global safari */

export default class {
  constructor() {
    this.isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    // Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
    this.isFirefox = typeof InstallTrigger !== 'undefined'; // Firefox 1.0+
    this.isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
      })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    // At least Safari 3+: "[object HTMLElementConstructor]"
    this.isChrome = false;
    this.isIE = !!document.documentMode; // At least IE6
    this.isEdge = /Edge\/12./i.test(navigator.userAgent);

    const isChromium = window.chrome,
      vendorName = window.navigator.vendor,
      isOpera = window.navigator.userAgent.indexOf('OPR') > -1,
      isIEedge = window.navigator.userAgent.indexOf('Edge') > -1;
    if (
      isChromium !== null &&
      isChromium !== undefined &&
      vendorName === 'Google Inc.' &&
      !isOpera &&
      !isIEedge
    ) {
      // is Google chrome
      this.isChrome = true;
    } else {
      // not Google chrome
    }

    if (isIEedge) {
      this.isEdge = true;
    }
  }
}
